import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _noop from 'lodash/noop';

// Builders
import ColumnConfig from '../../builders/ColumnConfig';
import CellConfig from '../../builders/CellConfig';

// Components
import ActionCellRenderer from '../../cellRenderers/ActionCellRenderer';
var makeMapCellPropsToComponentProps = function makeMapCellPropsToComponentProps() {
  var getActionsForRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _noop;
  var visibleActionCount = arguments.length > 1 ? arguments[1] : undefined;
  var getActionCellProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _noop;
  return function () {
    var actions = getActionsForRow.apply(void 0, arguments);
    // Added getActionCellProps so that we can pass row-specific props to the action cell
    var actionCellProps = getActionCellProps.apply(void 0, arguments);
    return _objectSpread({
      actions: actions,
      visibleActionCount: visibleActionCount
    }, actionCellProps);
  };
};
var makeCellConfig = function makeCellConfig(getActionsForRow, visibleActionCount, getActionCellProps) {
  var mapCellPropsToComponentProps = makeMapCellPropsToComponentProps(getActionsForRow, visibleActionCount, getActionCellProps);
  var cellConfig = new CellConfig().setComponent(ActionCellRenderer).setMapCellPropsToComponentProps(mapCellPropsToComponentProps);
  return cellConfig;
};
export var makeActionsCellConfig = function makeActionsCellConfig(_ref) {
  var title = _ref.title,
    width = _ref.width,
    className = _ref.className,
    headerClassName = _ref.headerClassName,
    getActionsForRow = _ref.getActionsForRow,
    visibleActionCount = _ref.visibleActionCount,
    getActionCellProps = _ref.getActionCellProps;
  var cellConfig = makeCellConfig(getActionsForRow, visibleActionCount, getActionCellProps);
  var columnConfig = new ColumnConfig('action').setHeader(title).setWidth(width).setCellClassName(className).setHeaderClassName(headerClassName).addCellConfig(cellConfig);
  return columnConfig;
};
export var getColumnsWithActions = function getColumnsWithActions(columns, actionConfig) {
  return [].concat(_toConsumableArray(columns), [actionConfig]);
};